module.exports = __webpack_public_path__ + "img/A4.401f3889.svg";